var map = {
	"./alert.svg": 189879,
	"./bell.svg": 886856,
	"./bundle-desc.svg": 746329,
	"./bundle.svg": 970557,
	"./info.svg": 329786,
	"./international-calls-desc.svg": 543301,
	"./international-calls.svg": 845288,
	"./internet-desc.svg": 862222,
	"./internet.svg": 753206,
	"./mobile-desc.svg": 478243,
	"./mobile.svg": 719418,
	"./phone-desc.svg": 810382,
	"./phone.svg": 497002,
	"./tv-desc.svg": 111466,
	"./tv.svg": 291290
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 111589;